import React from 'react';
import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';

import { HelperText } from 'components/common/ui';
import { Label, InputFieldV2 } from 'components/common/form-controls';
import styles from './fieldV2.style';

const FieldV2 = ({
  type = 'text',
  label = '',
  isRequired = false,
  disabled = false,
  placeholder = '',
  name,
  control = {},
  wrapperStyle = {},
  helperText,
  onInputChange = () => {},
  ...rest
}) => {
  return (
    <Box sx={{ ...styles.wrapper, ...wrapperStyle }}>
      {label && (
        <Label name={name} isRequired={isRequired} disabled={disabled}>
          {label}
        </Label>
      )}
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, value = '' },
          fieldState: { error = '' },
        }) => (
          <Box sx={styles.inputContainer}>
            <InputFieldV2
              type={type}
              error={error}
              onChange={onChange}
              value={value}
              disabled={disabled}
              placeholder={placeholder}
              name={name}
              onInputChange={onInputChange}
              {...rest}
            />
            {error?.message && <Box sx={styles.error}>{error?.message}</Box>}
            {helperText && (
              <HelperText
                helperText={helperText}
                styles={error?.message && styles.helperWithError}
              />
            )}
          </Box>
        )}
      />
    </Box>
  );
};

export default FieldV2;
